import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Skeleton placeholder. Uses the muted token and a quiet pulse so
 * loading states don't shout at the user.
 *
 * Heights are explicit so a skeleton lines up with the eventual content
 * (matching `Input` h-10, `Button` default h-10, etc.).
 */
function Skeleton({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  )
}

export { Skeleton }
